module.exports = __webpack_public_path__ + "static/media/language-earth.9020a22d.svg";